<template>
  <div>
    <user-detail-title
      first-bread="瑞普乐园"
      second-bread="瑞普乐园查看"
      first-url="/user/land"
      title-name="瑞普乐园查看"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="年份">
          <span>{{LookData.year}}</span>
        </el-form-item>
        <el-form-item label="图片">
          <el-image class="item-image" :src="'http://'+LookData.photoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="描述">
          <pre>
            {{LookData.description}}
          </pre>
        </el-form-item>
        <el-form-item label="创建时间">
          <span>{{LookData.createTime}}</span>

        </el-form-item>
        <el-form-item label="更新时间">
          <span>{{LookData.updateTime}}</span>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "LandLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/fairyland/getById/'+id).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>